export const SET_IS_LOADING_DATA = 'validations/SET_IS_LOADING_DATA';
export const SET_FORM_TYPE = 'validations/SET_FORM_TYPE';
export const SET_USER_DATA_TYPE = 'validations/SET_USER_DATA_TYPE';
export const FETCH_FORMS_TYPE = 'validations/FETCH_FORMS_TYPE';
export const SAVE_USER_DATA_TYPE = 'validations/SAVE_USER_DATA_TYPE';
export const SET_STAGE_TYPE = 'validations/SET_STAGE_TYPE';
export const RESET_USER_TYPE = 'validations/RESET_USER_TYPE';
export const RESTART_USER_TYPE = 'validations/RESTART_USER_TYPE';
